import { z } from 'zod'
import { AlertSettings } from '../../../domain/entities/AlertSettings'

export const AlertSettingsSchema = z
	.object({
		id: z.uuid().nonempty(),
		codigo: z.number().int().optional(),
		descricao: z.string().min(1),
		areas_monitoradas_vinculadas: z.array(
			z.object({
				id_area_monitorada_vinculada: z.uuid(),
				nome_area_monitorada_vinculada: z.string(),
			}),
		),
		usuarios_vinculados: z
			.array(
				z.object({
					id_usuario: z.uuid(),
					nome_usuario: z.string(),
				}),
			)
			.optional()
			.default([]),
		distancia_buffer: z.number().nonnegative(),
		porcentagem_confianca_minima: z.number().min(0).max(100),
	})
	.transform(
		(data) =>
			new AlertSettings(
				data.descricao,
				data.areas_monitoradas_vinculadas.map((area) => {
					return {
						id: area.id_area_monitorada_vinculada,
						name: area.nome_area_monitorada_vinculada,
					}
				}),
				data.distancia_buffer / 1000,
				data.porcentagem_confianca_minima,
				data.codigo,
				data.id,
				data.usuarios_vinculados.length,
			),
	)
